import { Link } from "react-router-dom";
import { Store, Phone, Clock, TicketPercent, Repeat } from "lucide-react";

export function Configurations() {
  return (
    <div className="w-full rounded-lg border-zinc-200/30 shadow-md border p-4 gap-4 flex flex-col sm:col-span-1 sm:row-span-5 md:col-span-1 md:row-span-3 lg:col-span-3 lg:row-span-2 xl:col-span-3 xl:row-span-3  bg-white">
      <div className="w-full flex">
        <span className="flex gap-2 text-scale-500 font-semibold text-lg items-center">
          <Store /> Configurações
        </span>
      </div>
      <div className="w-full flex-wrap flex gap-y-2 gap-x-4 mt-auto">
        <Link to="/configuracoes?tab=dados" className="flex gap-1 text-zinc-500 group items-center hover:text-scale-500">
          <Phone className="text-scale-500 w-5 h-5" /><span className="border-b border-white group-hover:border-scale-500">Contanto</span>
        </Link>
        <Link to="/configuracoes?tab=horarios" className="flex gap-1 text-zinc-500 group items-center hover:text-scale-500">
          <Clock className="text-scale-500 w-5 h-5" /><span className="border-b border-white group-hover:border-scale-500">Horários</span>
        </Link>
        <Link to="/cupom" className="flex gap-1 text-zinc-500 group items-center hover:text-scale-500">
          <TicketPercent className="text-scale-500 w-5 h-5" /><span className="border-b border-white group-hover:border-scale-500">Cupons</span>
        </Link>
        <Link to="/assinaturas?tab=configuracoes" className="flex gap-1 text-zinc-500 group items-center hover:text-scale-500">
          <Repeat className="text-scale-500 w-5 h-5" /><span className="border-b border-white group-hover:border-scale-500">Assinaturas</span>
        </Link>

      </div>
    </div>
  );
}
